import { TileMapLayer } from "../tiles.map.layer";
export class Float32Layer extends TileMapLayer {
    constructor(name, provider, options, enabled) {
        super(name, provider, options, enabled);
    }
}
//# sourceMappingURL=tiles.map.layer.float32.js.map